import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import Alert from "./components/alert/Alert";
import { router } from "./routes";
import AuthAction from './store/Actions/AuthActions';
import { GlobalDebug } from "./utills";

GlobalDebug(false,true);

function App() {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.AuthReducer.isLogin);
  const showAlert = useSelector((state) => state.AlertReducer.showAlert);
  const loading = useSelector((state) => state.GeneralReducer.isloading);
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("@user"));
    const token = localStorage.getItem('token');
    // console.log('userData', userData);
    if (userData != null && token != null) {
      dispatch(AuthAction.isLogin({ isLogin: true, userData: userData }));
    } else {
      dispatch(AuthAction.isLogin({ isLogin: false, userData: null }));
    }
  }, []);
  const antIcon = (
    <LoadingOutlined
      style={{ fontSize: 70, color: "var(--secondary-color)" }}
      spin
    />
  );
  return (
    <>
      {isLogin == null ? (
        <></>
      ) : (
        <>
          <RouterProvider router={router} />
          {showAlert && <Alert />}
          {loading && (
            <div
              style={{
                position: "fixed",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(26, 26, 26, 0.3)",
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10000
              }}
            >
              <Spin indicator={antIcon} />
            </div>
          )}

        </>
      )}
    </>
  );
}

export default App;
